import React from "react";

const styles = {
  green: "bg-emerald-50 dark:bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 ring-emerald-200 dark:ring-emerald-500/30",
  blue: "bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-400 ring-blue-200 dark:ring-blue-500/30",
  red: "bg-rose-50 dark:bg-rose-500/10 text-rose-700 dark:text-rose-400 ring-rose-200 dark:ring-rose-500/30",
  black: "bg-gray-900 dark:bg-slate-800 text-white ring-gray-700 dark:ring-slate-600",
};

const dot = {
  green: "bg-emerald-500",
  blue: "bg-blue-500",
  red: "bg-rose-500",
  black: "bg-gray-200 dark:bg-slate-500",
};

export default function ScoreBadge({ color = "blue", score = 0, tooltip = "" }) {
  return (
    <div className="group relative inline-flex items-center">
      <span
        className={[
          "inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold ring-1",
          styles[color] || styles.blue,
        ].join(" ")}
      >
        <span className={["h-2 w-2 rounded-full", dot[color] || dot.blue].join(" ")} />
        {color.toUpperCase()} • {score}%
      </span>

      {tooltip ? (
        <div className="pointer-events-none absolute left-1/2 top-full z-20 mt-2 w-[240px] -translate-x-1/2 opacity-0 group-hover:opacity-100 transition">
          <div className="rounded-2xl border border-gray-100 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-lg p-3 text-xs text-gray-700 dark:text-slate-300">
            {tooltip}
          </div>
        </div>
      ) : null}
    </div>
  );
}
